export default __webpack_public_path__ + "static/media/android_app_icon.422be0d2.png";